// extracted by mini-css-extract-plugin
export default {"imageWrapper":"HT-z","hovered":"IT-z","hoverImage":"JT-z","mainImage":"KT-z","imageNoBackground":"LT-z","fullSizeImage":"MT-z"};